import React, { useEffect, useMemo } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import TreeView from './Tree.js'
import redux from '../redux/index.js'
import { isSelected, openDocument, sortFileItems } from '../util.js'
import { makeSelectorUserdata } from '../redux/login/selectors.js'
import SearchInput from './Search.js'
import { styled } from '@pergas-common/pergas-components'

const TreeViewContainer = styled.div`
  display: flex;
  flex: 1;
  flex-grow: 1;
  flex-direction: column;
  padding-bottom: 50px;
  background: #fff;
`

const constructPayload = (pdsFields, rest) => {
  // eslint-disable-next-line
  const {
    city,
    address,
    name,
    email,
    homepage,
    phone,
    collection_name: collectionName,
    object_type_name: objectTypeName,
    postal_code: postalCode
  } = pdsFields

  return {
    ...rest,
    pds_user: name ?? '',
    pds_email: email ?? '',
    pds_phone: phone,
    pds_city: city ?? '',
    pds_address: address ?? '',
    pds_userhomesite: homepage ?? '',
    pds_contact: collectionName ?? '',
    pds_title: objectTypeName ?? '',
    pds_zipcode: postalCode ?? ''
  }
}

const FileView = ({
  strings,
  selected,
  selectedTemplateFileNode,
  expand,
  items,
  onSetSelectedTemplatesFolder,
  onGetRootFolder,
  onGetSubFolders,
  onSetSelectedTemplatesFile,
  searchValue,
  searchResults,
  isSearching,
  showSearchResults,
  onSearchValueChange,
  onStartSearch,
  onResetSearch,
  branding,
  ...rest
}) => {
  const dispatch = useDispatch()
  const selectUserdata = useMemo(makeSelectorUserdata, [])
  const userdata = useSelector((state) => selectUserdata(state))

  useEffect(() => {
    dispatch(redux.actions.templates.getTemplatesRootFolder())
  }, [])

  const onSetSelectedItem = (e, fileItem) => {
    if (!userdata.sc_root) {
      return
    }
    if (fileItem.type === 'rootfolder') {
      onSetSelectedTemplatesFolder(fileItem)
      onGetRootFolder(selected.currentFile)
    } else if (fileItem.type === 'folder') {
      onSetSelectedTemplatesFolder(fileItem)
      if (!expand[fileItem.id]) {
        onGetSubFolders(selected.currentFile, fileItem)
      }
    } else if (fileItem.type === 'file') {
      onSetSelectedTemplatesFile(fileItem)
      if (e === null || e?.detail === 2) {
        const payload = constructPayload(userdata, rest)
        openDocument(fileItem.uri, payload, userdata)
      }
    }
  }
  return (
    <TreeViewContainer>
      <SearchInput onSetSelectedItem={onSetSelectedItem} />
      {showSearchResults
        ? (
          <TreeView
            type='file'
            items={searchResults}
            expand={expand}
            sortItems={sortFileItems}
            isSelected={isSelected(selectedTemplateFileNode)}
            onItemSelected={onSetSelectedItem}
            branding={branding}
          />
          )
        : (
          <TreeView
            type='file'
            items={items}
            expand={expand}
            sortItems={sortFileItems}
            isSelected={isSelected(selectedTemplateFileNode)}
            onItemSelected={onSetSelectedItem}
            branding={branding}
          />
          )}
    </TreeViewContainer>
  )
}

const mapStateToProps = (state) => {
  const {
    selectedTemplateFileNode,
    trees,
    searchValue,
    searchResults,
    showSearchResults,
    isSearching
  } = state.templates
  const getFileMeta = (item) => {
    const DEFAULT = { expand: {}, items: [] }
    if (item) {
      return trees[`${item.type}:${item.id}`] || DEFAULT
    } else {
      return DEFAULT
    }
  }

  const { userData } = state.login
  const branding = userData.tmSettings?.branding

  const { expand, items } = getFileMeta(state.selected.currentFile)
  return {
    strings: state.locale.strings,
    selectedTemplateFileNode,
    selected: state.selected,
    expand,
    items,

    searchValue,
    searchResults,
    showSearchResults,
    isSearching,

    branding
  }
}

const mapDispatchToProps = (dispatch) => {
  const { templates } = redux.actions

  return {
    onSetSelectedTemplatesFolder: (folderItem) => {
      dispatch(templates.setSelectedTemplatesFolder(folderItem))
    },
    onGetRootFolder: (siteItem) => {
      dispatch(templates.getRootFolder(siteItem))
    },
    onGetSubFolders: (siteItem, folderItem) => {
      dispatch(templates.getSubFolder(siteItem, folderItem))
    },
    onSetSelectedTemplatesFile: (fileItem) => {
      dispatch(templates.setSelectedTemplatesFile(fileItem))
    },
    onSearchValueChange: (value) => {
      dispatch(templates.setSearchValue(value))
    },
    onStartSearch: (current, searchValue) => {
      dispatch(templates.searchFiles(current, searchValue))
    },
    onResetSearch: () => {
      dispatch(templates.resetSearch())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FileView)
